// @flow

import { createStore, applyMiddleware } from 'redux';
import type { Store as ReduxStore, StoreEnhancer } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';

import { rootEpic } from './epics/rootEpic';
import { initialState as initialStateCommon } from './reducers/commonReducer';
import { initialState as initialStateContent } from './reducers/contentReducer';
import { initialState as initialStateDeposit } from './reducers/depositReducer';
import { initialState as initialStateFranceConnect } from './reducers/franceConnect';
import { initialState as initialStateI18n } from './reducers/i18nReducer';
import { initialState as initialStateLanding } from './reducers/landingReducer';
import { initialState as initialStatePaypalConnect } from './reducers/paypalConnect';
import { reducers as rootReducer } from './reducers/rootReducer';
import { initialState as initialStateSession } from './reducers/sessionReducer';
import { initialState as initialStateTagManager } from './reducers/tagManagerReducer';
import { initialState as initialStateUserRegistration } from './reducers/userRegistrationReducer';
import { initialState as initialStateWebservice } from './reducers/websocketReducer';
import type { RootState, RootActions } from './types';

const initialRootState: RootState = {
  websocket: initialStateWebservice,
  content: initialStateContent,
  i18n: initialStateI18n,
  common: initialStateCommon,
  userRegistration: initialStateUserRegistration,
  deposit: initialStateDeposit,
  franceConnect: initialStateFranceConnect,
  session: initialStateSession,
  landing: initialStateLanding,
  tagManager: initialStateTagManager,
  paypalConnect: initialStatePaypalConnect,
};

const epicMiddleware = createEpicMiddleware();

const configureStore = (initialState: RootState) => {
  let middleware: StoreEnhancer<RootState, RootActions> = applyMiddleware(epicMiddleware);

  if (process.env.NODE_ENV === 'development') {
    const composeEnhancer = composeWithDevTools({ trace: true });
    middleware = composeEnhancer(middleware);
  }

  const store: ReduxStore<RootState, RootActions> = createStore(
    rootReducer,
    initialState,
    middleware,
  );

  epicMiddleware.run(rootEpic);

  if (module.hot) {
    module.hot.accept('./reducers/rootReducer', () => {
      const { reducers } = require('./reducers/rootReducer');
      store.replaceReducer(reducers);
    });
  }

  return store;
};

export const store = configureStore(initialRootState);
